module.exports = __webpack_public_path__ + "img/norton-secured.webp";